import React from "react";
import InputForm from "../../generales/InputForm";
import { capitalizeFirstLetter } from "../../../utils/utils";
import Action from "../../Action";
import { useState ,useEffect} from 'react';
import Modal from "react-modal";
import ModalLinKHost from "../ModalLinKHost";
const hostListModalSyncStyles = {
  content: {
    top: "50%",
    left: "50%",
    background: "#ffffff !important",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "40%",
    height: "90%",
    padding: "20px",
  },
};
const Step3 = ({hostSelected,setHostSelected,handleChange,cisData,changeOption,editActive,setCisData,server,handleShowPopup,languaje,mode,cisSelectedAux,setPoolRows2,brands_catalog,models_catalog}) => {
  const [hostsListSyncModalOpen, setHostsListSyncModalOpen] =useState(false);
  function openHostsListSyncModal() {
  //    setCisSelectedAux(elemento);
      setHostsListSyncModalOpen(true);
    }

  function closHostsListSyncModal() {
    
    setHostsListSyncModalOpen(false);
  }
  function vincular(){
    setCisData((prevState)=>{
      return {
          ...prevState,
            ['hostid']:hostSelected.hostid,
            ['ip']:hostSelected.agent_ip,
        ['affiliation']:hostSelected.alias,
        ['brand_id']:hostSelected.brand_id,
        ['location_id']:hostSelected.location_id,
        ['mac']:hostSelected.mac,
        ['model_id']:hostSelected.model_id,
        ['serial_no']:hostSelected.serialno,
        
      } 
      
  })
    closHostsListSyncModal()
  }
  function desvincular(){
    setHostSelected({hostid:0})

    setCisData((prevState)=>{
      return {
          ...prevState,
            ['hostid']:0,
            ['ip']:"",
        ['affiliation']:"",
        ['brand_id']:null,
        ['location_id']:null,
        ['mac']:"",
        ['model_id']:null,
        ['serial_no']:"",
        
      } 
      
  })
    closHostsListSyncModal()
  }
  return(
      <>
      <div className="cont-step-modal">
          <div className="compact-step-modal">
               <div className="title-step-modal">
              <div className="txt-title-step-modal">
                   {'Especificaciones Tecnicas'}
              </div>               
          </div>
          <div className="body-step-modal">
              <div className={"compact-body-step-modal "}>
                <div className="row-form-modal">
                  <div className="colum-form-modal">
                      {(brands_catalog.loading)?<div className='load-data-selector' >Cargando Datos. . .</div>:
                      <InputForm 
                      type='selector'
                      msgError={''}  
                      error={false} 
                      changeOption={changeOption}  
                      attr={'brand_id'} 
                      titulo={'Marca'} 
                      loading={brands_catalog.loading} 
                      data={brands_catalog.data.data} 
                      optionDefault={cisData.brand_id==null?0:cisData.brand_id} 
                      placeHolder={'Selecciona un Servicio'} 
                      disabled={false} 
                      isRequired={false}
                      endpoint={'Marcas'}
                      />
                      }
                      </div>
                <div className="colum-form-modal">
                      {(models_catalog.loading)?<div className='load-data-selector' >Seleccione una marca. . .</div>: 
                      <InputForm 
                      type='selector'
                      msgError={''} 
                      error={false} 
                      changeOption={changeOption}  
                      attr={'model_id'} 
                      titulo={'Modelo'} 
                      loading={models_catalog.loading} 
                      data={models_catalog.data.data} 
                      optionDefault={cisData.model_id==null?0:cisData.model_id} 
                      placeHolder={'Selecciona un grupo'} 
                      disabled={false} 
                      isRequired={false}
                      endpoint={'hostModel'}/>
                      }
                  </div>
                </div>
                
                <div className="row-form-modal">
                  <div className="colum-form-modal">
                      <InputForm  
                      error={false} 
                      type='input' 
                      handleInputChange={handleChange}  
                      attr={'serial_no'} 
                      titulo={'No. Serie'} 
                      text={cisData.serial_no} 
                      placeHolder={''} 
                      disabled={false} 
                      isRequired={false}
                      />
                  </div>
                <div className="colum-form-modal">
                      <InputForm  
                      error={false} 
                      type='input' 
                      handleInputChange={handleChange}  
                      attr={'mac'} 
                      titulo={'MAC'} 
                      text={cisData.mac} 
                      placeHolder={''}
                      disabled={false} 
                      isRequired={false}/>
                  </div>
                </div>
                 <div className="row-form-modal">
                  <div className="colum-form-modal">
                      <InputForm  
                      error={false} 
                      type='input' 
                      handleInputChange={handleChange}  
                      attr={'version'} 
                      titulo={'Versión'} 
                      text={cisData.version} 
                      placeHolder={''} 
                      disabled={false} 
                      isRequired={false}
                      />
                  </div>
                
                </div>
                
              </div>
          </div>
      </div>
      </div>      
      <Modal
      isOpen={hostsListSyncModalOpen}
      // isOpen={true}
      // onAfterOpen={afterOpenExeption}
      onRequestClose={closHostsListSyncModal}
      style={hostListModalSyncStyles}
      contentLabel="Example Modal2"
      // shouldCloseOnOverlayClick={false}
      >
        <ModalLinKHost vincular={vincular} desvincular={desvincular} isData={cisData} hostSelected={hostSelected} setHostSelected={setHostSelected} editActive={editActive} setCisData={setCisData}  server={server} handleShowPopup={handleShowPopup}  cisSelectRow={cisSelectedAux} setPoolRows={setPoolRows2} languaje={languaje}  mode={mode} closeAddHostModal={closHostsListSyncModal}   ></ModalLinKHost>
  </Modal>
      </>
  )
}

export default Step3;
 